import BreadCrumb from "../../../CommonComponents/BreadCrumb.tsx";
import React from "react";
import BannerComponent from "../BannerComponent.tsx";
import styles from "./AptechAssessmentAndTesting.module.scss";
import backgroundImg from "../../../../assets/images/aptech-assessment-and-testing-solutions-bg.png";
import logo from "../../../../assets/images/AptechAssessmentEBG.png";
import { Icon } from "../../../../assets/Icons.tsx";
import SectionComponent from "../SectionComponent.tsx";

const AptechAssessmentAndTesting: React.FC = () => {
  const breadcrumb = [
    { title: "Our Businesses", link: "/our-businesses" },
    {
      title: "Institutional Business",
      link: "/our-businesses/institutional-business/",
    },
    { title: "Aptech Assessment & Testing Solutions", link: "" },
  ];
  const capabilities = [
    {
      title: "Internet Based Testing (SaaS Model)",
      icon: "internetTesting",
    },
    {
      title: "Computer Based Test",
      icon: "computerTest",
    },
    {
      title: "OMR Based Testing",
      icon: "omrTesting",
    },
    {
      title: "Computer Based Evaluation",
      icon: "computerEvaluation",
    },
  ];
  return (
    <>
      <BreadCrumb menu={breadcrumb} />
      <div className="container mt-5 mb-5 d-flex flex-column gap-5">
        <BannerComponent
          bg={backgroundImg}
          title1="Aptech Assessment & Testing Solutions"
        />
        <div className="d-flex flex-column flex-md-row gap-4 align-items-center">
          <div className="d-none d-md-block">
            <img src={logo} alt="course logo" />
          </div>
          <div className="d-flex flex-column" style={{ gap: 25 }}>
            <p>
              <strong>Aptech</strong> offers comprehensive testing and
              assessment services for government, corporates and institutions to
              effectively measure competency and performance of employees in
              organisations. The assessments not only help professionals enhance
              their skills but also create career growth opportunities, driving
              both individual and organizational success.
            </p>
            <p>
              Aptech's security certifications includes{" "}
              <strong>
                {" "}
                ISO 9001:2015, ISO 20000-1, ISO 27001:2013, CMMi Level 3
                (Ver3.0), CERT-IN, STQC,
              </strong>{" "}
              and
              <strong> Tier IV</strong> Data Centre. In the last 5 years, Aptech
              has conducted computer-based tests (CBT) examinations for over 3
              crore students pan-India, with 275+ unique and 120+ end-to-end
              assessments.
            </p>
          </div>
        </div>
        <div>
          <p className="text-center heading3">
            The diversity of capabilities includes :
          </p>
          <div
            className="d-flex flex-column flex-md-row flex-wrap"
            style={{ gap: "20px" }}
          >
            {capabilities.map((c, index) => (
              <div key={index} className={styles.capabilitiesCont}>
                <Icon name={c.icon} />
                <p className="heading3">{c.title}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="d-flex flex-row justify-content-center">
          <div className={styles.txtCont}>
            <p className="text-center para">
              <strong> Aptech Assessment & Testing Solutions</strong> is the
              market leader in this segment, having conducted thousands of tests
              to date and with a distinguished list of{" "}
              <strong>100+ corporate</strong> & university entities and{" "}
              <strong>60+ government bodies.</strong>
            </p>
          </div>
        </div>
        <div className="d-flex flex-row justify-content-center">
          <div className={styles.lastSectionCont}>
            <SectionComponent
              desc="For any leads, queries, or feedback please contact"
              title="<p>Aptech Assessments & Testing Solutions - <strong> Building a Skilled, Future-Ready India</strong></p>"
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default AptechAssessmentAndTesting;
